import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./App";
import Categorie from "./Categorie";
import Informazioni from "./Informazioni";
import Sottocategorie from "./Sottocategorie";
import PappaTime from "./PappaTime";
import AssunzioneFarmaci from "./AssunzioneFarmaci";
import AcquaFacile from "./AcquaFacile";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/PappaTime" element={<PappaTime />} />
      <Route path="/categorie" element={<Categorie />} />
      <Route path="/informazioni" element={<Informazioni />} />
      <Route path="/sottocategorie" element={<Sottocategorie />} />
      <Route path="/assunzione-farmaci" element={<AssunzioneFarmaci />} />
      <Route path="/acqua-facile" element={<AcquaFacile />} />
    </Routes>
  </BrowserRouter>,
);
